import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { PvhCOLineEntity } from "../entities/pvh-co-line.entity";
import { PvhOrderFilter } from "packages/libs/shared-models/src/common/pvh/pvh-order-filter";
import { ExternalReq } from "packages/libs/shared-models/src/common/pvh/externalreq";



@Injectable()
export class PvhCOLineRepository extends Repository<PvhCOLineEntity> {

  constructor(@InjectRepository(PvhCOLineEntity) private pvhCoLineRepository: Repository<PvhCOLineEntity>
  ) {
    super(pvhCoLineRepository.target, pvhCoLineRepository.manager, pvhCoLineRepository.queryRunner);
  }


  // async getCoLineData(req?: PvhOrderFilter): Promise<any[]> {
  //   const query = this.createQueryBuilder('co')
  //     .select(`DISTINCT 
  //     co.po_number,
  //     co.po_line,
  //     co.plm_style,
  //     co.co_date,
  //     co.item_no,
  //     co.status,
  //     co.error_msg,
  //     DATE_FORMAT(co.created_at, '%m/%d/%Y %H:%i') as raised_date,
  //     co.created_user,
  //     co.co_number,
  //     co.id,
  //     co.buyer_name
  // FROM 
  //     pvh_co_lineco
  // WHERE 
  //     co.status = 'Success' 
  //     AND co.is_active = true`);


  //   if (req?.poNumber !== undefined) {
  //     const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
  //     query.andWhere(`co.po_number IN (:...poNumbers)`, { poNumbers });
  //   }

  //   if (req?.itemNo !== undefined) {
  //     query.andWhere(`co.item_no = :itemNo`, { itemNo: req.itemNo });
  //   }

  //   if (req?.coNumber !== undefined) {
  //     query.andWhere(`co.co_number LIKE :coNumber`, { coNumber: `%${req.coNumber}%` });
  //   }

  //   if (req?.externalRefNo !== undefined) {
  //     query.andWhere(`co.buyer_name ='${req.externalRefNo}'`)
  //   }

  //   // query.andWhere(`(co.status = 'Success' AND co.isActive = 1) OR co.status != 'Success'`);


  //   return await query.getRawMany();

  // }

  async getCoLineData(req?: PvhOrderFilter): Promise<any[]> {
  const query = this.createQueryBuilder('co')
    .select(`DISTINCT co.po_number, co.po_line, co.plm_style, co.co_date, co.item_no, co.status, co.error_msg,
    DATE_FORMAT(co.created_at, '%m/%d/%Y %H:%i') as raised_date, co.created_user, co.co_number, co.id, co.buyer_name,co.port,co.short_description,co.division,co.gender,co.delivery_address,co.trans_mode,co.delivery_date,co.total_quantity,co.order_value,co.updated_at`)
    .andWhere(`NOT(co.status = 'Success' AND co.is_active = 0)`)
    
    .orderBy('co.created_at', 'DESC');

  if (req?.poNumber !== undefined) {
    const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
    query.andWhere(`co.po_number IN (:...poNumbers)`, { poNumbers });
  }

  if (req?.itemNo !== undefined) {
    query.andWhere(`co.item_no = :itemNo`, { itemNo: req.itemNo });
  }

  if (req?.coNumber !== undefined) {
    query.andWhere(`co.co_number LIKE :coNumber`, { coNumber: `%${req.coNumber}%` });
  }

  if (req?.externalRefNo !== undefined) {
    query.andWhere(`co.buyer_name = :externalRefNo`, { externalRefNo: req.externalRefNo });
  }

  return await query.getRawMany();
}







  async getCoPoNumber(req?: ExternalReq): Promise<any[]> {
    // console.log(req,'?????????????????')
    const query = this.createQueryBuilder('co')
      .select(`co.id,co.po_number`)
      .groupBy(`co.po_number`)

    //  .where(`buyer_po <> NULL`)
    if (req.externalRef === '') {
      // If req.externalRef is undefined or empty, fetch all data
      // No need to add any conditions to the query
    } else if (req.externalRef !== undefined) {
      // If req.externalRef is defined and not empty, add it as a condition
      query.andWhere(`co.buyer_name = :externalRef`, { externalRef: req.externalRef });
    }
    return await query.getRawMany();
  }
  async getItem(req?: ExternalReq): Promise<any[]> {
    // console.log(req,'////////////////')
    const query = this.createQueryBuilder('co')
      .select(`co.id,co.item_no`)
      .groupBy(`co.item_no`)
    //  .where(`item_no <> NULL`)

    if (req.externalRef === '') {

    } else if (req.externalRef !== undefined) {
      // If req.externalRef is defined and not empty, add it as a condition
      query.andWhere(`co.buyer_name = :externalRef`, { externalRef: req.externalRef });
    }
    return await query.getRawMany();
  }


  async getDataforCOLineCreation(): Promise<any> {
    const query = this.createQueryBuilder('co')
      .select(`co.id, co.po_number, co.item_no, co.buyer_name,co.po_line,co.delivery_date`)
      .where(` status !='Success' AND status != 'Inprogress' AND is_active = true`)
      .orderBy(` created_at`, 'ASC')
    return await query.getRawOne();
  }

  async getDataforCOLineEdit(): Promise<any[]> {
    const query = this.createQueryBuilder('co')
      .select(`co.id, co.po_number, co.item_no, co.buyer,co.po_line,co.co_number`)
      .where(` status != 'Open' AND status != 'Failed' AND is_active = true`)
      .orderBy(` created_at`, 'ASC')
    return await query.getRawMany();
  }




}